import React, { useEffect, useState } from 'react';
import { apiFetch } from './api';

const money = (value, showSign = false) => Number(value || 0).toLocaleString('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  signDisplay: showSign ? 'always' : 'auto',
});

const LeaderboardPage = ({ currentUsername }) => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError('');
    apiFetch('/api/paper/leaderboard', { signal: controller.signal })
      .then(async (response) => {
        const body = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(body.error || 'Unable to load leaderboard');
        setEntries(body.leaderboard || []);
      })
      .catch((requestError) => {
        if (requestError.name !== 'AbortError') setError(requestError.message);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, []);

  return (
    <main className="leaderboard-page">
      <section className="leaderboard-card">
        <div className="leaderboard-heading">
          <strong>Leaderboard</strong>
          <span>{entries.length} users</span>
        </div>
        {loading && <div className="leaderboard-message">Loading…</div>}
        {error && <div className="leaderboard-message error">{error}</div>}
        {!loading && !error && (
          <div className="leaderboard-scroll">
            <table className="leaderboard-table">
              <thead>
                <tr>
                  <th className="number">#</th>
                  <th>User</th>
                  <th className="number">Running</th>
                  <th className="number">Total P/L</th>
                  <th className="number">Win rate</th>
                  <th className="number">Closed</th>
                  <th className="number">Open</th>
                </tr>
              </thead>
              <tbody>
                {entries.map((entry) => (
                  <tr key={entry.username} className={entry.username === currentUsername ? 'current-user' : ''}>
                    <td className="number rank">{entry.rank}</td>
                    <td className="leaderboard-user">{entry.username}</td>
                    <td className="number">{money(entry.running_amount)}</td>
                    <td className={`number ${entry.total_pnl >= 0 ? 'positive' : 'negative'}`}>
                      {money(entry.total_pnl, true)}
                    </td>
                    <td className="number">{Number(entry.win_rate || 0).toFixed(1)}%</td>
                    <td className="number">{entry.closed_trades}</td>
                    <td className="number">{entry.open_trades}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </main>
  );
};

export default LeaderboardPage;
